(function () {
  var SLIDE_MS = 600;
  var HOVER_MQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  function supportsCardHover() {
    return HOVER_MQ.matches;
  }

  function preload(urls) {
    urls.forEach(function (src) {
      var el = new Image();
      el.src = src;
    });
  }

  function showCardHoverMeta(card, hoverInfo) {
    card.classList.add('is-card-hover-meta');
    if (hoverInfo) hoverInfo.hidden = false;
  }

  function hideCardHoverMeta(card, hoverInfo) {
    card.classList.remove('is-card-hover-meta');
    if (hoverInfo) hoverInfo.hidden = true;
  }

  function initCard(card) {
    const isNativeSecondary = card.getAttribute('data-card-native-secondary') === 'true';

    const hoverInfo = card.querySelector('[data-card-hover-info]');
    const nativeSizesEl = hoverInfo && hoverInfo.querySelector('[data-card-sizes]');
    const nativeColorCountEl = hoverInfo && hoverInfo.querySelector('[data-card-color-count]');
    const hasNativeHoverContent =
      (nativeSizesEl && nativeSizesEl.children.length > 0) ||
      !!nativeColorCountEl;

    if (isNativeSecondary) {
      if (!hasNativeHoverContent || !supportsCardHover()) return;
      card.addEventListener('mouseenter', () => {
        showCardHoverMeta(card, hoverInfo);
      });
      card.addEventListener('mouseleave', () => {
        hideCardHoverMeta(card, hoverInfo);
      });
      return;
    }

    var images = [];
    try {
      images = JSON.parse(card.dataset.cardImages || '[]');
    } catch (e) {
      images = [];
    }

    var currentIndex = 0;
    var animating = false;
    var animTimer = null;

    var img = card.querySelector('[data-card-img]');
    var pictureEl = img ? img.parentElement : null;
    var sizesEl = hoverInfo && hoverInfo.querySelector('[data-card-sizes]');
    var colorCountEl = hoverInfo && hoverInfo.querySelector('[data-card-color-count]');
    var hasHoverContent =
      (sizesEl && sizesEl.children.length > 0) || !!colorCountEl;
    var arrowsEl = card.querySelector('[data-card-arrows]');
    var progressEl = card.querySelector('[data-card-progress]');
    var progressIndicator = card.querySelector('[data-card-progress-indicator]');
    var prevBtn = card.querySelector('[data-card-prev]');
    var nextBtn = card.querySelector('[data-card-next]');

    if (!img || !pictureEl) return;

    var originalSrc = img.getAttribute('src') || '';
    var originalSrcset = img.getAttribute('srcset') || '';
    var hasMultiple = images.length > 1;

    if (hasMultiple) preload(images);

    // Set indicator width once (1/N of the bar) and position it at index 0
    if (progressIndicator && images.length > 0) {
      progressIndicator.style.width = (100 / images.length) + '%';
      progressIndicator.style.transition = 'none';
      progressIndicator.style.transform = 'translateX(0)';
    }

    function updateProgress(idx) {
      if (!progressIndicator) return;
      progressIndicator.style.transition = 'transform 0.9s ease';
      progressIndicator.style.transform = 'translateX(' + (idx * 100) + '%)';
    }

    function clearAnimation() {
      if (animTimer) {
        clearTimeout(animTimer);
        animTimer = null;
      }
      pictureEl.querySelectorAll('.card-custom__incoming').forEach(function (el) {
        pictureEl.removeChild(el);
      });
      img.style.transition = '';
      img.style.transform = '';
      animating = false;
    }

    function slide(toSrc, toSrcset, toIdx, direction) {
      if (animating) return;
      animating = true;

      var incoming = document.createElement('img');
      incoming.src = toSrc;
      incoming.className = img.className + ' card-custom__incoming';
      incoming.style.transform = 'translateX(' + (direction * 100) + '%)';
      incoming.style.transition = 'transform ' + SLIDE_MS + 'ms ease';
      pictureEl.appendChild(incoming);

      img.style.transition = 'transform ' + SLIDE_MS + 'ms ease';

      // Force reflow before triggering transition
      incoming.getBoundingClientRect();

      // Update progress at the same moment the slide starts
      updateProgress(toIdx);

      img.style.transform = 'translateX(' + (-direction * 100) + '%)';
      incoming.style.transform = 'translateX(0)';

      animTimer = setTimeout(function () {
        img.setAttribute('src', toSrc);
        if (toSrcset) {
          img.setAttribute('srcset', toSrcset);
        } else {
          img.removeAttribute('srcset');
        }
        img.style.transition = '';
        img.style.transform = '';
        pictureEl.removeChild(incoming);
        currentIndex = toIdx;
        animating = false;
        animTimer = null;
      }, SLIDE_MS);
    }

    function showIndex(idx) {
      if (!images[idx] || idx === currentIndex) return;
      var direction = idx > currentIndex ? 1 : -1;
      // Wrap-around direction
      if (currentIndex === images.length - 1 && idx === 0) direction = 1;
      if (currentIndex === 0 && idx === images.length - 1) direction = -1;
      slide(images[idx], images[idx], idx, direction);
    }

    function restoreOriginal() {
      clearAnimation();
      img.setAttribute('src', originalSrc);
      if (originalSrcset) {
        img.setAttribute('srcset', originalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      currentIndex = 0;
      if (progressIndicator) {
        progressIndicator.style.transition = 'none';
        progressIndicator.style.transform = 'translateX(0)';
      }
    }

    function onEnter() {
      if (progressEl && hasMultiple) {
        progressEl.hidden = false;
        if (progressIndicator) {
          progressIndicator.style.transition = 'none';
          progressIndicator.style.transform = 'translateX(0)';
          progressIndicator.getBoundingClientRect();
        }
      }
      if (hasMultiple) showIndex(1);
      if (arrowsEl && hasMultiple) arrowsEl.hidden = false;
      if (hasHoverContent) showCardHoverMeta(card, hoverInfo);
    }

    function onLeave() {
      restoreOriginal();
      if (arrowsEl) arrowsEl.hidden = true;
      if (progressEl) progressEl.hidden = true;
      hideCardHoverMeta(card, hoverInfo);
    }

    if (!supportsCardHover()) return;

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showIndex((currentIndex - 1 + images.length) % images.length);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        showIndex((currentIndex + 1) % images.length);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-card-custom]').forEach(function (card) {
      if (card.dataset.cardCustomInit) return;
      card.dataset.cardCustomInit = '1';
      initCard(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () { init(); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();
